import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';

import OnOffByScroll from '../../../Animation/onOffByScroll';
import { AuthContext } from '../../../auth';
import various from '../../../General/various';
import {
  getPaymentTypeChoices,
  instructorPaymentMethodCreate,
  instructorPaymentMethodUpdate,
  instructorPaymentMethodIsExists,
  getInstructorAllPaymentMethods,
} from '../../../Apis/apiOfManaged';
import { selectDefaultCheck } from '../../../CommonFunction/validators';
import Footer from '../../../Footer/footer';
import { localStorageArrayHandler } from '../../../CommonFunction/managePermission';
import BreadCrumbs from '../../../General/breadCrumbs';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'start',
      '& > span': {
        display: 'inline-block',
        marginRight: '24px',
        fontSize: '0.9rem',
      },
      '& #title': {
        fontWeight: 'bold',
        fontSize: theme.typography.fontSize,
      },
    },
  },
  titles: {},
  inputs: {},
  helptext: {},
  readText: {},
  error: {
    color: 'red',
    fontSize: '0.7em',
  },
  container: {
    marginTop: '64px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media screen and (max-width:800px)': {
      '& > div': {
        width: '100%',
      },
    },
    '& > form': {
      '& > div': {
        width: '70%',
        display: 'flex',
        margin: '0 auto',
        marginBottom: '32px',

        '& > div': {
          textAlign: 'start',
          display: 'flex',
          justifyContent: 'start',
          '& > img': {
            maxWidth: '300px',
            maxHeight: '300px',
            objectFit: 'contain',
          },
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
        },

        '& $titles': {
          width: '30%',
          marginRight: '32px',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > label': {
            width: '100%',
            textAlign: 'end',
            fontSize: '1rem',
            '@media screen and (max-width:750px)': {
              textAlign: 'start',
              marginBottom: '16px',
            },
          },
          '& > span': {
            color: 'red',
          },
        },

        '& $inputs': {
          width: '70%',
          flexWrap: 'wrap',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > input, & > textarea, & > select': {
            width: '100%',
            height: '40px',
            padding: '8px',
            fontFamily: theme.typography.fontFamily,
            border: '0.5px solid grey',
            borderRadius: '0.5em',
            boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1) inset',
            '&:focus': {
              outline: `1.2px ${theme.palette.primary.main} outset`,
            },
          },
          '& > textarea': {
            minHeight: '160px',
          },
          '& > input[type="checkbox"]': {
            boxShadow: 'none',
          },
          '& $helptext': {
            fontSize: '0.8rem',
            color: 'grey',
            '& > a': {
              textDecoration: 'underline',
              '&:link': {
                color: theme.palette.primary.main,
              },
            },
          },
        },

        '@media screen and (max-width:750px)': {
          flexWrap: 'wrap',
        },
      },
      '& $readText': {
        margin: '16px auto',
        textAlign: 'start',
        fontSize: '0.8rem',
        color: 'grey',
      },
    },
  },
  button: {
    width: '100%',
    // marginTop: '88px !important',
    justifyContent: 'end',
    '& > button': {
      width: '100%',
      height: '40px',
      display: 'block',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'bold',
      borderRadius: '0.5em',
      border: 'none',
      padding: '4px 8px',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
      color: '#fff',
      cursor: 'pointer',
    },
  },
}));

const InstructorPaymentMethodCreate = () => {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {},
  });

  const { isAuth } = useContext(AuthContext);
  const permissions = localStorageArrayHandler('parse', various.permissionKey);

  const [date, setDate] = useState();

  // 決済方法登録の制御系ステート
  const [paymentTypeChoices, setPaymentTypeChoices] = useState([]);
  const [paymentTypeStates, setPaymentTypeStates] = useState({});
  const [paymentMethodCounts, setPaymentMethodCounts] = useState({});
  const [isAddedPaymentMethod, setIsAddedPaymentMethod] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [businessSiteUrls, setBusinessSiteUrls] = useState({}); // 既存データからの初期値（読み取り専用）
  const [currentStripeAccountData, setCurrentStripeAccountData] = useState({
    // 現在セッションでの入力値管理
    business_website_url: '',
    tokushoho_url: '',
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [isExists, setIsExists] = useState(false);
  // 決済方法モデルに登録する値を格納するステート（決済方法が増える毎に追加すること）
  const [paymentMethodData, setPaymentMethodData] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);
  const [paypayAccounts, setPaypayAccounts] = useState([]);
  const [paymentLinksAccounts, setPaymentLinksAccounts] = useState([]);
  // ...他の決済方法も同様

  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  const searchParams = new URLSearchParams(location.search);
  const instructor_uuid =
    (location.state && location.state.uuid) || searchParams.get('uuid'); // ← uuidキーの値を取得
  const seminar_uuid =
    (location.state && location.state.seminar_uuid) ||
    searchParams.get('seminar_uuid'); // ← seminar_uuidキーの値を取得

  const CRUMBS = [
    location?.state?.previous !== '/manage/instructor_settings_for_instructor'
      ? { name: '管理画面Top', path: '/manage/index' }
      : '',
    location?.state?.previous === '/manage/instructor_settings_for_instructor'
      ? {
          name: '指導者設定',
          path: '/manage/instructor_settings_for_instructor',
        }
      : { name: '指導者一覧', path: '/manage/instructor_index' },
    {
      name: '指導者の決済方法の登録',
      path: '/manage/instructor_payment_method_create',
    },
  ];

  // if (paymentTypeChoices) console.log('paymentTypeChoices', paymentTypeChoices);
  // if (paymentTypeStates) console.log('paymentTypeStates', paymentTypeStates);
  // if (bankAccounts) console.log('bankAccounts', bankAccounts);
  // if (paypayAccounts) console.log('paypayAccounts', paypayAccounts);
  // if (paymentLinksAccounts)
  //   console.log('paymentLinksAccounts', paymentLinksAccounts);
  // if (paymentMethodCounts)
  //   console.log('paymentMethodCounts', paymentMethodCounts);
  // if (isAddedPaymentMethod)
  //   console.log('isAddedPaymentMethod', isAddedPaymentMethod);
  // if (isExists) console.log('isExists', isExists);
  // if (paymentMethodData) console.log('paymentMethodData', paymentMethodData);
  // console.log('location.state.previous', location.state.previous);
  // if (businessSiteUrls) console.log('businessSiteUrls', businessSiteUrls);
  // console.log('instructor_uuid', instructor_uuid);

  // Init
  useEffect(() => {
    const weekday = ['日', '月', '火', '水', '木', '金', '土'];
    const d = new Date();
    setDate(
      d.getFullYear() +
        '年' +
        (d.getMonth() + 1) +
        '月' +
        d.getDate() +
        '日' +
        '（' +
        weekday[d.getDay()] +
        '）'
    );
  }, []);

  useEffect(() => {
    getPaymentTypeChoices(setPaymentTypeChoices);
  }, []);

  useEffect(() => {
    if (instructor_uuid) {
      // 既存の決済方法があるかを確認
      instructorPaymentMethodIsExists(setIsExists, instructor_uuid);
    }
  }, [instructor_uuid]);

  useEffect(() => {
    if (isExists && instructor_uuid) {
      getInstructorAllPaymentMethods(setPaymentMethodData, instructor_uuid);
    }
  }, [isExists, instructor_uuid]);

  // paymentTypeChoicesが更新されたときにステートを初期化
  // DBにモデリングされている決済方法をBooleanステートに変換（e.g. bank -> is_bank）
  useEffect(() => {
    if (paymentTypeChoices.length > 0) {
      const initialStates = {};
      const paymentMethodCounts = {};
      paymentTypeChoices.forEach((choice) => {
        initialStates[`is_${choice.value}`] = false; // 初期値はfalse
        paymentMethodCounts[`${choice.value}`] = 0; // 初期値は0
      });
      setPaymentTypeStates(initialStates);
      setPaymentMethodCounts(paymentMethodCounts);
    }
  }, [paymentTypeChoices]);

  // paymentMethodCountsに格納されているすべての要素の件数を合計
  useEffect(() => {
    const totalCount = Object.values(paymentMethodCounts).reduce(
      (acc, count) => acc + count,
      0
    );
    setTotalCount(totalCount);
  }, [paymentMethodCounts]);

  // 決済方法ステートが更新された場合に、その配列の件数をpaymentMethodCountsに集計
  useEffect(() => {
    const counts = {};
    if (bankAccounts.length > 0) {
      counts.bank = bankAccounts.length;
    }
    if (paypayAccounts.length > 0) {
      counts.paypay = paypayAccounts.length;
    }
    if (paymentLinksAccounts.length > 0) {
      counts.paymentlinks = paymentLinksAccounts.length;
    }
    // 他の決済方法も同様に追加
    setPaymentMethodCounts((prev) => ({ ...prev, ...counts }));
  }, [bankAccounts, paypayAccounts, paymentLinksAccounts]);

  // 決済方法が追加されているかを判定するステートを更新
  useEffect(() => {
    const hasAddedPaymentMethod = Object.values(paymentMethodCounts).some(
      (count) => count > 0
    );
    setIsAddedPaymentMethod(hasAddedPaymentMethod);
  }, [paymentMethodCounts]);

  // PaymentLinksを運用している場合、ビジネスURL等をセット
  useEffect(() => {
    if (
      paymentMethodData?.payment_links_accounts &&
      paymentMethodData?.payment_links_accounts.length > 0
    ) {
      const account = paymentMethodData.payment_links_accounts[0];
      setBusinessSiteUrls({
        business_website_url: account.business_website_url,
        tokushoho_url: account.tokushoho_url,
      });
    }
  }, [paymentMethodData?.payment_links_accounts]);

  // Submit
  const onSubmit = async (data) => {
    // 必要なaccounts stateを更新 --> この場でSubmit処理を行うと非同期処理の関係上、Accounts関連ステートが更新されていない場合があるため、ここでセットし遅延処理でAPIコールする
    // 条件分岐はすべてのForm要素で行うべきだが、必須要素が一つでもあれば他の要素も埋まっているとみなす
    // ここでの処理は、予約登録をせずにFormを埋めた後にSubmitボタンを押下した際のステートの更新不具合を防ぐためのものであり、予約登録をしているAccountsステートはカンパケ状態という認識でよい

    // 非同期処理の関係でis_activeがハンドラーでセットされないことがあるが、ここでは常にTrueなのでここでフォールバックする
    if (!data?.is_active) {
      data.is_active = true; // デフォルトで有効にする
    }

    if (data.bank_name) {
      setBankAccounts([...bankAccounts, { ...data }]);
    }
    if (data.paypay_id) {
      setPaypayAccounts([...paypayAccounts, { ...data }]);
    }
    if (data.url) {
      setPaymentLinksAccounts([...paymentLinksAccounts, { ...data }]);
    }
    // 他の決済方法も同様に追加
    setIsSubmit(true);
  };

  // submit後に発火する処理
  useEffect(() => {
    if (isSubmit) {
      const create = async () => {
        // ここでInstructorPaymentMethodモデルのペイロードを作成
        const cleanAccounts = (accounts, allowedKeys, requiredFields = []) =>
          accounts
            .filter((acc) => {
              // 必須フィールドが空でないかチェック --> 空であれば除外
              return requiredFields.every(
                (field) => acc[field] && acc[field].toString().trim() !== ''
              );
            })
            .map((acc) =>
              Object.fromEntries(
                // オブジェクトのキーを許可されたものだけにフィルタリング
                Object.entries(acc).filter(([key]) => allowedKeys.includes(key))
              )
            );
        // PaymentLinksAccountsからStripeAccount関連のデータを抽出
        const extractStripeAccountData = (paymentLinksAccounts) => {
          if (paymentLinksAccounts.length > 0) {
            const firstAccount = paymentLinksAccounts[0];
            return {
              business_website_url: firstAccount.business_website_url || '',
              tokushoho_url: firstAccount.tokushoho_url || '',
              // api_secret_key等もこの画面で登録させることになったら、こことPaymentLinksフォームとそのハンドラーに追記
            };
          }
          return {};
        };

        const allowedBankKeys = [
          'account_holder',
          'is_active',
          'is_default',
          'bank_name',
          'branch_name',
          'account_number',
          'account_type',
        ];
        const allowedPaypayKeys = [
          'account_holder',
          'is_active',
          'is_default',
          'paypay_email',
          'paypay_id',
          'support_page_url',
        ];
        const allowedPaymentLinksKeys = [
          'account_holder',
          'is_active',
          'is_default',
          'url',
          'amount',
        ];

        const payload = {
          instructor: instructor_uuid,
          default_payment_type: paymentMethodData.default_payment_type || null,
          bank_accounts: cleanAccounts(bankAccounts, allowedBankKeys, [
            'account_number',
          ]),
          paypay_accounts: cleanAccounts(paypayAccounts, allowedPaypayKeys, [
            'paypay_id',
          ]),
          payment_links_accounts: cleanAccounts(
            paymentLinksAccounts,
            allowedPaymentLinksKeys,
            ['url', 'amount']
          ),
          // 他の決済方法も同様に追加
          // 決済方法の基礎データとなるStripeAccount関連のデータも渡す
          stripe_account: extractStripeAccountData(paymentLinksAccounts),
        };

        // console.log('Submitting payment method data:', payload);
        try {
          if (isExists) {
            await instructorPaymentMethodUpdate(payload);
            console.log('update finish!');
          } else {
            await instructorPaymentMethodCreate(payload);
            console.log('create finish!');
          }
          setIsSubmit(false);
          navigate(location.state.previous, {
            state: {
              previous: location.pathname,
              uuid: seminar_uuid,
              instructor_uuid: instructor_uuid,
            },
          });
        } catch (error) {
          console.error('Error in createInstance:', error);
        }
      };
      create();
    }
    // eslint-disable-next-line
  }, [isSubmit, bankAccounts, paypayAccounts, paymentLinksAccounts]);

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  // Contents

  // initial form
  const defaultSelect = () => {
    return (
      <div>
        <div className={classes.titles}>
          <label htmlFor="決済方法">{'決済方法'}</label>
        </div>
        <div className={classes.inputs}>
          <select
            id="payment_method"
            defaultValue="choice"
            {...register('payment_method', {
              required: { value: false, message: '入力必須の項目です' },
            })}
          >
            <option value="choice">選択してください</option>
            {paymentTypeChoices.map((choice) => (
              <option key={choice.value} value={choice.value}>
                {choice.label}
              </option>
            ))}
          </select>
          <div className={classes.helptext}>
            選択肢に該当の方法がない場合は、管理者へお問い合わせください。
          </div>
          {errors.payment_method?.message && (
            <div className={classes.error}>{errors.payment_method.message}</div>
          )}
        </div>
      </div>
    );
  };

  // DBにモデリングされている決済方法に応じて表示するフォーム
  const bankForm = () => {
    return (
      <>
        <div>
          <div className={classes.titles}>
            <label htmlFor="bank_account">銀行口座</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="bank_name"
              type="text"
              {...register('bank_name', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 100,
                  message: '100文字以内でお願いします',
                },
              })}
            />
            <div className={classes.helptext}>銀行名を入力してください。</div>
            {errors.bank_name?.message && (
              <div className={classes.error}>{errors.bank_name.message}</div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="branch_name">支店名</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="branch_name"
              type="text"
              {...register('branch_name', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 100,
                  message: '100文字以内でお願いします',
                },
              })}
            />
            <div className={classes.helptext}>支店名を入力してください。</div>
            {errors.branch_name?.message && (
              <div className={classes.error}>{errors.branch_name.message}</div>
            )}
          </div>
        </div>
        {/* 次はaccount_number */}
        <div>
          <div className={classes.titles}>
            <label htmlFor="account_number">口座番号</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="account_number"
              type="text"
              {...register('account_number', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 20,
                  message: '20文字以内でお願いします',
                },
              })}
            />
            <div className={classes.helptext}>口座番号を入力してください。</div>
            {errors.account_number?.message && (
              <div className={classes.error}>
                {errors.account_number.message}
              </div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="account_holder">講座名義人</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="account_holder"
              type="text"
              {...register('account_holder', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 100,
                  message: '100文字以内でお願いします',
                },
              })}
            />
            <div className={classes.helptext}>
              講座名義人を入力してください。
            </div>
            {errors.account_holder?.message && (
              <div className={classes.error}>
                {errors.account_holder.message}
              </div>
            )}
          </div>
        </div>
        {/* 次はaccount_type -> 選択肢は普通または当座 */}
        <div>
          <div className={classes.titles}>
            <label htmlFor="account_type">口座種別</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <select
              id="account_type"
              defaultValue="choice"
              {...register('account_type', {
                required: { value: true, message: '入力必須の項目です' },
                validate: {
                  message: (v) =>
                    selectDefaultCheck(v)
                      ? null
                      : `口座種別を選択してください。`,
                },
              })}
            >
              <option value="choice">選択してください</option>
              <option value="ordinary">普通</option>
              <option value="checking">当座</option>
            </select>
            <div className={classes.helptext}>口座種別を選択してください。</div>
            {errors.account_type?.message && (
              <div className={classes.error}>{errors.account_type.message}</div>
            )}
          </div>
        </div>
        {/* is_defaultの制御のためのチェックボックス */}
        <div>
          <div className={classes.titles}>
            <label htmlFor="is_default">デフォルト口座に設定</label>
          </div>
          <div className={classes.inputs}>
            <input
              id="is_default"
              type="checkbox"
              {...register('is_default', {
                required: { value: false, message: '入力必須の項目です' },
              })}
            />
            <div className={classes.helptext}>
              この決済方法をデフォルトにする場合はチェックを入れてください。なお、デフォルト設定は”決済方法毎”に設定されます。たとえば銀行口座を複数登録した場合、どの口座をデフォルトにするかを選択してください。
            </div>
            {errors.is_default?.message && (
              <div className={classes.error}>{errors.is_default.message}</div>
            )}
          </div>
        </div>
        {/* 次は、他の決済方法を登録する場合にハンドラーを発火させるためのボタン */}
        <div className={classes.button}>
          <button
            type="button"
            onClick={handleSubmit(handleAddBankAccount)} // handleSubmitでラップしないとreact-hook-formのバリデーションが効かない
            style={{ backgroundColor: 'green' }}
          >
            この決済方法を登録予約した上で他の決済方法を登録する
          </button>
        </div>
        {/* 次は、他の決済方法を登録せずにSubmitするボタン */}
        <div className={classes.button}>
          <button
            type="button"
            onClick={() => {
              handleAddBankAccount(handleSubmit(onSubmit));
            }}
          >
            登録
          </button>
        </div>
      </>
    );
  };

  const paypayForm = () => {
    // APIに必要な要素は、paypay_email, paypay_id, support_page_url
    return (
      <>
        <div>
          <div className={classes.inputs}>
            <input
              id="account_holder"
              type="hidden"
              value="N/A" // PayPayでは口座名義人は不要なので、ダミー値を設定
              {...register('account_holder', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 100,
                  message: '100文字以内でお願いします',
                },
              })}
            />
          </div>
        </div>
        <div>
          <div className={classes.inputs}>
            <input
              id="paypay_email"
              type="hidden"
              value="dummy_email@example.com" // PayPayではメールアドレスは必須ではないが、APIの仕様上ダミー値を設定
              {...register('paypay_email', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 100,
                  message: '100文字以内でお願いします',
                },
              })}
            />
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="paypay_id">PayPay ID</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="paypay_id"
              type="text"
              {...register('paypay_id', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 50,
                  message: '50文字以内でお願いします',
                },
              })}
            />
            <div className={classes.helptext}>
              PayPayに登録されているIDを入力してください。
            </div>
            {errors.paypay_id?.message && (
              <div className={classes.error}>{errors.paypay_id.message}</div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="support_page_url">サポートページURL</label>
          </div>
          <div className={classes.inputs}>
            <input
              id="support_page_url"
              type="url"
              defaultValue={'https://paypay.ne.jp/guide/send/'}
              {...register('support_page_url', {
                required: { value: false, message: '入力必須の項目です' },
                pattern: {
                  value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                  message: '有効なURLを入力してください',
                },
              })}
            />
            <div className={classes.helptext}>
              セミナー参加者が迷わないように、適切なPayPayのサポートページ（支払方法）のURLを入力してください。
            </div>
            {errors.support_page_url?.message && (
              <div className={classes.error}>
                {errors.support_page_url.message}
              </div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="is_default">デフォルト口座に設定</label>
          </div>
          <div className={classes.inputs}>
            <input
              id="is_default"
              type="checkbox"
              {...register('is_default', {
                required: { value: false, message: '入力必須の項目です' },
              })}
            />
            <div className={classes.helptext}>
              この決済方法をデフォルトにする場合はチェックを入れてください。なお、デフォルト設定は”決済方法毎”に設定されます。たとえば銀行口座を複数登録した場合、どの口座をデフォルトにするかを選択してください。
            </div>
            {errors.is_default?.message && (
              <div className={classes.error}>{errors.is_default.message}</div>
            )}
          </div>
        </div>
        <div className={classes.button}>
          <button
            type="button"
            onClick={handleSubmit(handleAddPaypayAccount)} // handleSubmitでラップしないとreact-hook-formのバリデーションが効かない
            style={{ backgroundColor: 'green' }}
          >
            この決済方法を登録予約した上で他の決済方法を登録する
          </button>
        </div>
        <div className={classes.button}>
          <button
            type="button"
            onClick={() => {
              handleAddPaypayAccount(handleSubmit(onSubmit));
            }}
          >
            登録
          </button>
        </div>
      </>
    );
  };

  const paymentLinksForm = () => {
    // APIに必要な要素は url, amount
    return (
      <>
        <div>
          <div className={classes.inputs}>
            <input
              id="account_holder"
              type="hidden"
              value="N/A" // Payment Linksでは口座名義人は不要なので、ダミー値を設定
              {...register('account_holder', {
                required: { value: true, message: '入力必須の項目です' },
                maxLength: {
                  value: 100,
                  message: '100文字以内でお願いします',
                },
              })}
            />
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="url">支払いURL</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="url"
              type="url"
              {...register('url', {
                required: { value: true, message: '入力必須の項目です' },
                pattern: {
                  value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                  message: '有効なURLを入力してください',
                },
              })}
            />
            <div className={classes.helptext}>
              Stripeダッシュボード上で生成したPaymentLinksの支払いURLを入力してください。
            </div>
            {errors.url?.message && (
              <div className={classes.error}>{errors.url.message}</div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="amount">金額</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="amount"
              type="number"
              {...register('amount', {
                required: { value: true, message: '入力必須の項目です' },
                min: {
                  value: 1,
                  message: '金額は1以上で入力してください',
                },
                max: {
                  value: 1000000,
                  message: '金額は1000000以下で入力してください',
                },
              })}
            />
            <div className={classes.helptext}>
              PaymentLinksの支払いURLを生成した際に設定した金額を入力してください。
            </div>
            {errors.amount?.message && (
              <div className={classes.error}>{errors.amount.message}</div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="business_website_url">
              講師個人ウェブサイトURL
            </label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="business_website_url"
              type="url"
              disabled={businessSiteUrls?.business_website_url}
              style={
                businessSiteUrls?.business_website_url
                  ? {
                      cursor: 'not-allowed',
                    }
                  : {}
              }
              {...register('business_website_url', {
                required: { value: true, message: '入力必須の項目です' },
                pattern: {
                  value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                  message: '有効なURLを入力してください',
                },
              })}
            />
            <div className={classes.helptext}>
              Stripeアカウントを本番環境に移行する際に提出された、講師個人ウェブサイトのURLを入力してください。
            </div>
            {errors.business_website_url?.message && (
              <div className={classes.error}>
                {errors.business_website_url.message}
              </div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="tokushoho_url">特定商取引法に基づく表記URL</label>
            <span> *</span>
          </div>
          <div className={classes.inputs}>
            <input
              id="tokushoho_url"
              type="url"
              disabled={businessSiteUrls?.tokushoho_url}
              style={
                businessSiteUrls?.tokushoho_url ? { cursor: 'not-allowed' } : {}
              }
              {...register('tokushoho_url', {
                required: { value: true, message: '入力必須の項目です' },
                pattern: {
                  value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                  message: '有効なURLを入力してください',
                },
              })}
            />
            <div className={classes.helptext}>
              特定商取引法に基づく表記のURLを入力してください。
            </div>
            {errors.tokushoho_url?.message && (
              <div className={classes.error}>
                {errors.tokushoho_url.message}
              </div>
            )}
          </div>
        </div>
        <div>
          <div className={classes.titles}>
            <label htmlFor="is_default">デフォルト口座に設定</label>
          </div>
          <div className={classes.inputs}>
            <input
              id="is_default"
              type="checkbox"
              {...register('is_default', {
                required: { value: false, message: '入力必須の項目です' },
              })}
            />
            <div className={classes.helptext}>
              この決済方法をデフォルトにする場合はチェックを入れてください。
              なお、デフォルト設定は”決済方法毎”に設定されます。たとえば銀行口座を複数登録した場合、どの口座をデフォルトにするかを選択してください。
            </div>
            {errors.is_default?.message && (
              <div className={classes.error}>{errors.is_default.message}</div>
            )}
          </div>
        </div>
        <div className={classes.button}>
          <button
            type="button"
            onClick={handleSubmit(handleAddPaymentLinksAccount)} // handleSubmitでラップしないとreact-hook-formのバリデーションが効かない
            style={{ backgroundColor: 'green' }}
          >
            この決済方法を登録予約した上で他の決済方法を登録する
          </button>
        </div>
        <div className={classes.button}>
          <button
            type="button"
            onClick={() => {
              handleAddPaymentLinksAccount(handleSubmit(onSubmit));
            }}
          >
            登録
          </button>
        </div>
      </>
    );
  };

  // 決済方法ごとの一時保存またはSubmitハンドラー
  const handleAddBankAccount = (submit = null) => {
    // Accountモデルのペイロード
    const bankData = {
      // 以下は抽象モデルのフィールド
      account_holder: getValues('account_holder'),
      is_active: true,
      is_default: getValues('is_default') || false,
      // 以下は具象モデルのフィールド
      bank_name: getValues('bank_name'),
      branch_name: getValues('branch_name'),
      account_number: getValues('account_number'),
      account_type: getValues('account_type'),
      // ...他の項目
    };
    setBankAccounts((prev) => {
      const updated = [...prev, bankData];
      if (typeof submit === 'function') {
        // ここでsubmitを呼ぶことで、onSubmitで最新の配列が参照できる
        submit();
      }
      return updated;
    });
    setPaymentTypeStates((prev) => ({ ...prev, is_bank: false }));
    if (typeof submit !== 'function') {
      reset(); // 予約時のみリセット
    }
  };

  const handleAddPaypayAccount = (submit = null) => {
    const paypayData = {
      // 以下は抽象モデルのフィールド
      account_holder: getValues('account_holder') || 'N/A', // PayPayでは口座名義人は不要なので、ダミー値を設定
      is_active: true,
      is_default: getValues('is_default') || false,
      // 以下は具象モデルのフィールド
      paypay_email: getValues('paypay_email') || 'dummy_email@example.com',
      paypay_id: getValues('paypay_id'),
      support_page_url: getValues('support_page_url'),
      // ...他の項目
    };
    setPaypayAccounts((prev) => {
      const updated = [...prev, paypayData];
      if (typeof submit === 'function') {
        // ここでsubmitを呼ぶことで、onSubmitで最新の配列が参照できる
        submit();
      }
      return updated;
    });
    setPaymentTypeStates((prev) => ({ ...prev, is_paypay: false }));
    if (typeof submit !== 'function') {
      reset(); // 予約時のみリセット
    }
  };

  const handleAddPaymentLinksAccount = (submit = null) => {
    const paymentLinksData = {
      // 以下は抽象モデルのフィールド
      account_holder: getValues('account_holder') || 'N/A',
      is_active: true,
      is_default: getValues('is_default') || false,
      // 以下は具象モデルのフィールド
      url: getValues('url'),
      amount: getValues('amount'),
      // 以下は関連モデルのフィールド --> 一旦、PaymentLinksAccountのオブジェクトに格納しSubmitデータからPayloadを作成する際に分離しAPIに渡す
      business_website_url: getValues('business_website_url'),
      tokushoho_url: getValues('tokushoho_url'),
      // ...他の項目
    };

    // 最初のPaymentLinks登録時または既存データがない場合、現在セッションのStripeAccountデータを更新
    if (
      paymentLinksAccounts.length === 0 &&
      !businessSiteUrls.business_website_url
    ) {
      setCurrentStripeAccountData({
        business_website_url: getValues('business_website_url'),
        tokushoho_url: getValues('tokushoho_url'),
      });
    }

    setPaymentLinksAccounts((prev) => {
      const updated = [...prev, paymentLinksData];
      if (typeof submit === 'function') {
        // ここでsubmitを呼ぶことで、onSubmitで最新の配列が参照できる
        submit();
      }
      return updated;
    });
    setPaymentTypeStates((prev) => ({ ...prev, is_payment_links: false }));
    if (typeof submit !== 'function') {
      console.log('Resetting payment links form fields');
      reset();
    }
  };

  // defaultSelectをwatchで監視
  const paymentMethod = watch('payment_method');
  useEffect(() => {
    if (paymentMethod) {
      // すべてfalseで初期化
      setPaymentTypeStates({
        is_bank: false,
        is_paypay: false,
        is_payment_links: false,
        // 他の決済種別もfalseで初期化
      });

      // 選択されたpaymentMethodに応じて表示Formをディスパッチャする
      console.log('Selected payment method:', paymentMethod);
      if (paymentMethod === 'bank') {
        setPaymentTypeStates((prev) => ({
          ...prev,
          is_bank: true,
        }));
      } else if (paymentMethod === 'paypay') {
        setPaymentTypeStates((prev) => ({
          ...prev,
          is_paypay: true,
        }));
      } else if (paymentMethod === 'paymentlinks') {
        setPaymentTypeStates((prev) => ({
          ...prev,
          is_payment_links: true,
        }));
      }
      // 他の決済方法も同様に追加
    }
  }, [paymentMethod]);

  // PaymentLinks用のフォームが描画された際に、適切なデータをプリセット
  useEffect(() => {
    if (paymentTypeStates.is_payment_links) {
      // 優先順位: 1. 既存データ(businessSiteUrls), 2. 現在セッションの入力データ(currentStripeAccountData)
      let presetData = {};

      if (
        businessSiteUrls.business_website_url &&
        businessSiteUrls.tokushoho_url
      ) {
        // 既存データがある場合はそれを使用（読み取り専用）
        presetData = businessSiteUrls;
      } else if (
        currentStripeAccountData.business_website_url &&
        currentStripeAccountData.tokushoho_url
      ) {
        // 既存データがなく、現在セッションで入力済みの場合はそれを使用
        presetData = currentStripeAccountData;
      }

      if (presetData.business_website_url) {
        setValue('business_website_url', presetData.business_website_url);
      }
      if (presetData.tokushoho_url) {
        setValue('tokushoho_url', presetData.tokushoho_url);
      }
    }
  }, [
    paymentTypeStates.is_payment_links,
    businessSiteUrls,
    currentStripeAccountData,
    setValue,
  ]);

  return (
    <>
      <div style={{ margin: '80px' }}>
        <OnOffByScroll place="General" />
      </div>
      {!isAuth ? (
        <>
          <div>
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={handleAuth}
            >
              ログイン
            </span>
            してください。
          </div>
        </>
      ) : permissions.includes('admin') ||
        permissions.includes('instructor') ||
        permissions.includes('organizer') ? (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">指導者決済情報の登録</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <BreadCrumbs crumbs={CRUMBS} />
          <div className={classes.container}>
            <form
              method="POST"
              encType="multipart/form-data"
              onSubmit={handleSubmit(onSubmit)}
            >
              {defaultSelect()}
              {paymentTypeStates.is_bank && bankForm()}
              {paymentTypeStates.is_paypay && paypayForm()}
              {paymentTypeStates.is_payment_links && paymentLinksForm()}
              {/* 他の決済方法があればここに追加 */}
              {isAddedPaymentMethod && (
                <>
                  <div className={classes.readText}>
                    ※ 既に登録予約されている決済方法が{totalCount}
                    件あります。他の決済方法を追加する場合は、同様に上記"決済方法"を選択してください。
                  </div>
                  <div className={classes.readText}>
                    ※ 現在、{paymentMethodCounts.bank || 0}件の銀行口座と
                    {paymentMethodCounts.paypay || 0}件のPayPay口座と
                    {paymentMethodCounts.paymentlinks || 0}
                    件のPaymentLinks口座が登録予約されています。
                    {/* 他の決済方法も同様に表示 */}
                  </div>
                  {paymentMethod === 'choice' && (
                    <div className={classes.button}>
                      <button type="submit">決済方法を登録</button>
                    </div>
                  )}
                </>
              )}
            </form>
          </div>
        </>
      ) : permissions === 'null' ? (
        setTimeout(() => {
          window.location.reload(true);
        }, 500)
      ) : (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">指導者情報の登録</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <div className={classes.container}>権限がありません</div>
        </>
      )}
      <Footer />
    </>
  );
};
export default InstructorPaymentMethodCreate;
